import React, { useEffect, useState } from 'react';
import { IFormattedTextPageContent, INotificationScreenContent } from '../MobileAppTypes';
import { IScreenEditorProps } from './SharedTypes';
import Editor from '../../GenericForms/Editor';

interface INotificationScreenEditorProps extends IScreenEditorProps {
  content: INotificationScreenContent;
}

const NotificationScreenEditor: React.FC<INotificationScreenEditorProps> = ({
  content,
  errors,
  onContentChange,
  onFilesChange,
  onValidationChange
}) => {
  const [localContent, setLocalContent] = useState<INotificationScreenContent>(content);

  useEffect(() => {
    setLocalContent(content);
  }, [content]);

  const updateContent = (updates: Partial<INotificationScreenContent>) => {
    const newContent = { ...localContent, ...updates };
    setLocalContent(newContent);
    onContentChange(newContent);
    
    // Validate on change
    const validationErrors = validate(newContent);
    onValidationChange(validationErrors);
  };

  const validate = (contentToValidate: INotificationScreenContent = localContent): string[] => {
    const errors: string[] = [];
    return errors;
  };

  return (
    <div className="form-section">
      <h4>Notification Screen Content</h4>
      <div className="form-horizontal">
        
        <div className="form-group">
          <label className="col-sm-3 control-label">Header Content</label>
          <div className="col-sm-9">
            <Editor
              options="simple"
              height="normal"
              value={localContent.headerContent || ''}
              changed={(content: string) => updateContent({ headerContent: content })}
              readOnly={false}
              placeholder="Enter your header content here..."
              hideAlign
            />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-3 control-label">Footer Content</label>
          <div className="col-sm-9">
            <Editor
              options="simple"
              height="normal"
              value={localContent.footerContent || ''}
              changed={(content: string) => updateContent({ footerContent: content })}
              readOnly={false}
              placeholder="Enter your footer content here..."
              hideAlign
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationScreenEditor;